import { FC, ReactNode } from 'react'
import { Empty, TableHeader, TableItem } from '@/ui/components'
import { Loading } from '@/ui/views'

const TableItems: FC<TableComponentProps> = (props): ReactNode => {
    const { loading, list } = props

    return (
        <div id='sideover-panel' className='relative overflow-hidden rounded-md max-h-[82.25vh] min-h-[82.25vh]'>
            {
                (!loading && list?.length !== 0) &&
                <table className='w-full table text-sm text-left text-gray-500'>
                    <TableHeader {...props} />

                    <tbody className='w-full pb-5 custom-scrollbar max-h-[82.25vh] min-h-[82.25vh]'>
                        <TableItem {...props} />
                    </tbody>
                </table>
            }

            {
                loading &&
                <div className='w-full flex items-center justify-center py-32'>
                    <Loading />
                </div>
            }

            {
                (!loading && list?.length === 0) &&
                <Empty />
            }
        </div>
    )
}

export default TableItems
